import { FC, RefObject } from 'react';
import { ListingHashtagEntity } from '@/swagger';
import classNames from 'classnames';

interface ItemFeatureProps {
  tags: string[];
  content: string;
  titleRef?: RefObject<HTMLDivElement>;
  hashtags?: Array<ListingHashtagEntity>;
}

const ItemFeature: FC<ItemFeatureProps> = ({ tags, content, titleRef, hashtags }) => {
  return (
    <div className={'py-4 border-b border-gray300'}>
      <div>
        <section
          ref={titleRef}
          id='house-feature'
          className={classNames('text-lg font-medium text-dark-grey uppercase my-3')}
        >
          物件特色
        </section>
        <div className={'flex flex-row flex-wrap'}>
          {(Array.isArray(tags) ? tags : []).map((item) => (
            <Tags value={item} key={item} />
          ))}
        </div>
        <div className={'flex flex-row flex-wrap text-base text-fb-blue font-semibold'}>
          {(Array.isArray(hashtags) ? hashtags : []).map((item) =>
            item.hyperlink ? (
              <a
                key={item.id}
                href={item.hyperlink}
                target={'_blank'}
                rel={'noreferrer noopener'}
                className={'mr-2 mb-2'}
              >
                <p className='hoverable:hover:underline'>#{item.hashtag}</p>
              </a>
            ) : (
              <p key={item.id} className={'mr-2 mb-2'}>
                #{item.hashtag}
              </p>
            )
          )}
        </div>
        <p className=' leading-normal tracking-wide text-dark-grey whitespace-pre-wrap'>{content}</p>
      </div>
    </div>
  );
};
const Tags = ({ value }: { value: string }) => {
  return (
    <div className={'px-2 border border-brand mr-2 mb-2'}>
      <p className='text-sm leading-normal  text-brand'>{value}</p>
    </div>
  );
};
export default ItemFeature;
